<template>
  <div class="carousel">
    <div class="item" v-for="(game,i) in games" :class="boxClass(i)" :style="'background-image: url('+ gameBanner(game.name) +');'">
      <div class="logo">
        <img :src="gameLogo(game.name)" alt="">
      </div>
    </div>
    <div class="balls">
      <div class="dot" v-for="(game,i) in games" :class="dotClass(i)" @click="clickDot(i)">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "carousel",
    props: ['type', 'name'],
    data() {
      return {
        nowIndex: 0,
        animate: false,
        timeout: null
      }
    },
    computed: {
      games() {
        return this.$dataManager.findGamesByType(this.type)
      },
      total() {
        return this.$dataManager.findGamesByType(this.type).length
      },
      prev() {
        return (this.nowIndex - 1 < 0) ? this.total - 1 : this.nowIndex - 1
      },
      after() {
        return (this.nowIndex + 1 === this.total) ? 0 : this.nowIndex + 1
      },
    },
    methods: {

      clickDot: function (idx) {
        this.nowIndex = idx
      },
      change: function (i) {
        if (!this.animate) {
          this.nowIndex += i
          var $this = this;
          $this.animate = true
          this.timeout = setTimeout(() => {
            $this.animate = false
          }, 305)
        }
      },
      boxClass(idx) {
        return (idx == this.nowIndex) ? 'now' : (idx == this.prev) ? 'pre' : (idx == this.after) ? 'after' : (idx == this.prevHide) ? 'prevHide' : (idx == this.afterHide) ? 'afterHide' : ''
      },
      dotClass(idx) {
        return (idx == this.nowIndex) ? 'now' : ''
      },
      getWidth: function () {
        this.clientWidth = parseInt(document.querySelector('.trygame').offsetWidth)
      },
      gameBanner: function (game) {
        var url = 'images/game/' + game + '/trygame_banner.png';
        return url
      },
      gameLogo: function (game) {
        var url = 'images/game/' + game + '/trygame_logo.png';
        return url
      },
    },
    mounted: function () {
      setInterval(()=>{
        this.nowIndex ++
      },3000)
    },
    watch: {
      nowIndex(val, old) {
        if (val == this.total) {
          this.nowIndex = 0
        }
        if (val < 0) {
          this.nowIndex = this.total - 1
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import 'carousel';
</style>
